import React from 'react';
import { connect } from 'react-redux';

import { useFormContext } from 'react-hook-form';
import { Image } from 'react-bootstrap';
import { PermissionCodes } from 'config/PermissionCodes';
import CustomDropdownWithButtonAndPrompt from 'components/base/CustomDropdownWithButtonAndPrompt';
import addImage from '../../../assets/images/addx1.png';

const mapPropsToState = (state) => ({
  // linkedEarningRules: state.createCampaign.campaign.linkedEarningRules,
  earningRuleList: state.earningRuleList.earningRuleList,
});
function EarningRuleDropdownWithButtonAndPrompt({
  earningRuleList,
  title,
  valueFieldName,
  customOnChange = () => { },
  onFocus = () => { },
  description,
  bottomTips,
  placeholder,
  dropDownSearchBarPlaceholder,
  hasAddButton = false,
  addButtonInfo,
  promptConfig,
  isPrompt = false,
  formErrorId = valueFieldName,
  defaultFilter,
}) {
  const { watch, formState: { errors }, setValue } = useFormContext();
  const watchEarningRule = watch(valueFieldName)
  const defaultValue = {
    value: watchEarningRule,
    label: watchEarningRule?.pk
      ? `[ID: ${watchEarningRule?.pk}] ${watchEarningRule?.name}`
      : watchEarningRule?.name,
  }

  const defaultAddButtonInfo = {
    requires: PermissionCodes.changeEarningRule,
    children: <Image src={addImage} />,
    customClass: 'earning-rule-add-new-link-button',
  }
  const onSelectChange = (value) => {
    if (valueFieldName) {
      setValue(valueFieldName, value?.value || {}, { shouldDirty: true })
    }
    customOnChange(value?.value);
  };

  return (
    <CustomDropdownWithButtonAndPrompt
      title={title}
      description={description}
      bottomTips={bottomTips}
      titleStyle={isPrompt ? '' : 'create-section-label-no-top-space'}
      defaultValue={defaultValue}
      setValue={onSelectChange}
      source={earningRuleList}
      hasAddButton={hasAddButton}
      addButtonInfo={hasAddButton ? { ...defaultAddButtonInfo, ...addButtonInfo } : {}}
      placeholder={placeholder}
      dropDownSearchBarPlaceholder={dropDownSearchBarPlaceholder}
      onFocus={onFocus}
      labelContainPk={true}
      errors={errors}
      formErrorId={formErrorId}
      promptConfig={promptConfig}
      loadMoreAction={'earningRuleList/getEarningRuleListWithTypes'}
      filterAction={'earningRuleList/getEarningRuleListWithTypes'}
      defaultFilter={defaultFilter}
    />
  );
}



export default connect(mapPropsToState)(EarningRuleDropdownWithButtonAndPrompt);
